import React, { Component, Fragment } from 'react';
import autoBind from 'react-autobind';
import { observer } from 'mobx-react';

import moment from 'moment';

import Circle from '../sys/Circle.jsx';

import api from '../api/server_api.js';
import store from '../store/store.js';

import OptionsList from '../coms/OptionsList.jsx';
import TouristsTable from '../coms/TouristsTable.jsx';

import Paper from 'material-ui/Paper'
import TextField from 'material-ui/TextField';

import {Toolbar, ToolbarTitle, ToolbarGroup} from 'material-ui/Toolbar';
import Divider from 'material-ui/Divider';

import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';
import RaisedButton from 'material-ui/RaisedButton';


@observer
class NewOrderSettings extends Component {
  
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { 
      loading: false
    };
  }

  componentWillMount(){
    store.setBackFunction( () => { store.replacePage('/neworder') });
    store.setErrors(false);
    if ( !store.options.tur.id || !store.options.hotel.id ) store.replacePage('/');
  }

  validate() {
    let valid = true; 
    const opt = store.options;
    const trs = store.options.tourists;
    const type = this.props.type;
    store.trimOptions();
    if (type === 'a' && opt.city === -1 ) valid = false;
    if (!opt.manag || !opt.telef ) valid = false;
    for (var i = 0; i < trs.length; i++) {
      if (!moment(trs[i].birthdate, 'DD.MM.YYYY').isValid() ) valid = false;
      if ( ~trs[i].birthdate.indexOf("_") ) valid = false;
      if (!trs[i].fio || !trs[i].passport) valid = false;
    }
    return valid;
  }

  onSubmit() {
    store.setErrors(true);
    const cb = (data) => { 
      if ( data ) {
        store.message({title: "", 
          message: "Заявка отпралена!"});
        store.replacePage('/');
        store.initOptions();
      } else {
        store.message({title: "Ошибка", 
          message: "Не удалось создать заявку, ошибка сервера..."});
        this.setState({ loading: false }); 
        store.replacePage('/');
      };
    }

    if ( this.validate() ) {
      const opt = store.options;
      localStorage.setItem('manag', opt.manag);
      localStorage.setItem('telef', opt.telef);
      let data;
      data = `
post_data_section\r\n
manag=${opt.manag}\r\n
telef=${opt.telef}\r\n
tur=${opt.tur.id}\r\n
hotel=${opt.hotel.id}\r\n
city=${store.cities[opt.city]}\r\n
food=${opt.food?'on':'off'}\r\n
bilet=${opt.bilet?'on':'off'}\r\n
transfer=${store.transfers[opt.transfer]}\r\n
summa=${parseInt(opt.summa, 10)}\r\n
prim=${opt.prim.replace(/\r\n|\r|\n/g,"<br>")}\r\n`;
      var i;
      const trs = store.options.tourists;
      for (i = 0; i < trs.length; i++) {
        data = data + `
fio_${i}=${trs[i].fio}\r\n
birthdate_${i}=${trs[i].birthdate}\r\n
passport_${i}=${trs[i].passport}\r\n
tel_${i}=${trs[i].tel}\r\n`
        }
      data = data + 'end_data_section';
      this.setState({ loading: true });
      api.newOrder(data, cb);
    } else {
      store.message({message:'Заполните все обязательные поля!', title:'Ошибка!'});
    }
  }

  render() {
    const loading = this.state.loading;
    const turType = this.props.type;
    const OptionsPaperStyle = {padding: 20};
    const InfoPaperStyle = {
      display: 'none', 
      padding: 20, 
      width:"49%", 
      minHeight: 500,
      float: "right"
    };

    const $plan_mest = (turType === 'a' 
          ? ( <RaisedButton  
            label="План мест автобуса"
            onClick={()=>{ store.showLightBox(`${store.host}/plan_mest.jpg?id=${store.options.tur.id}`) } }
          /> )
          : null );

    return (
    <Fragment>
      
      <Toolbar>
      
        <ToolbarTitle text="Новая заявка на бронирование тура"/>
        <ToolbarGroup>
          {$plan_mest}
        </ToolbarGroup>
      </Toolbar>
      
      <Paper style={InfoPaperStyle}>
      </Paper>

      <Paper style={OptionsPaperStyle}>
        <OptionsList turType={turType} />
      </Paper>
      
      <TouristsTable />

      <div>
        <TextField
          name = "prim"
          value={store.options.prim}
          onChange={(event) => store.changeOption("prim", event.target.value)}
          floatingLabelText="Дополнительные сведения"
          multiLine={true}
          rows={2}
          rowsMax={2}
          fullWidth={true}
        />
      </div>
      
      <Fragment>
        <div style={{marginTop: 30, marginBottom: 150, padding: 50, float: "left", width: "60%"}}>
          <RaisedButton
            label={loading? "Отправляем" : "Отправить заявку"}
            primary={true} 
            onClick = {this.onSubmit}
            fullWidth={true}
            disabled={loading}
          />
        </div>
        <div style={{marginTop: 30, marginBottom: 150, padding: 50, float: "left", width: "20%"}}>
          <RaisedButton
            label="Отмена" 
            secondary={true} 
            onClick = {() => store.replacePage('/')}
            fullWidth={true}
            disabled={loading}
          />
        </div>
      </Fragment>

    </Fragment> )
  }
}

export default NewOrderSettings;


// WEBPACK FOOTER //
// ./src/pages/NewOrderSettings.jsx